import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import type { Fleet, SimplifiedFleet } from '../../interfaces/fleet';

@Component({
  selector: 'app-fleet-description-parameters',
  imports: [TranslatePipe],
  templateUrl: './fleet-description-parameters.component.html',
  styleUrl: './fleet-description-parameters.component.scss',
})
export class FleetDescriptionParametersComponent {
  public readonly fleet = input.required<Fleet | SimplifiedFleet>();
  public readonly isCell = input(true);
  public readonly isModal = input(false);

  protected readonly DictionaryCode = DictionaryCode;
}
